
import { batchBusiness } from 'json/data-statistics'
export let batchTabs = [
  {
    label: '监控数据统计',
    value: 'statisc'
  },
  {
    label: '异常列表',
    value: 'abnormalList'
  }
]
export let tableLabelsOfBase = [
  {
    label: '异常内容',
    value: 'message'
  },
  {
    label: '异常类型',
    value: 'business_show'
  },
  {
    label: '异常发生时间',
    value: 'created_date'
  }
]

export let orderLabels = [
  {
    label: '母亲姓名',
    value: 'data.motherName'
  },
  {
    label: '母亲证件号',
    value: 'data.motherCardId'
  },
  {
    label: '产品编码',
    value: 'data.productCode'
  },
  {
    label: '样本号',
    value: 'data.proBarcode'
  },
  {
    label: '合同号',
    value: 'data.contractCode'
  }
]
export let reportLabels = [
  {
    label: '报告名称',
    value: 'data.reportType'
  },
  {
    label: '年份',
    value: 'data.year'
  }
]
export let tableLabels = [
  ...tableLabelsOfBase,
  {
    label: '用户手机号',
    value: 'data.customerUserMobile'
  },
  ...orderLabels,
  ...reportLabels
]
export let tableLabelsOfOrder = [
  ...tableLabelsOfBase,
  ...orderLabels
]
export let tableLabelsOfUser = [
  ...tableLabelsOfBase,
  {
    label: '用户手机号',
    value: 'data.customerUserMobile'
  },
  {
    label: '用户CPS系统ID',
    value: 'data.customerUserId'
  }
]
export let tableLabelsOfReport = [
  ...tableLabelsOfBase,
  ...reportLabels
]
export let filterLabels = [
  {
    label: '异常类型',
    type: 'select',
    value: 'businessType',
    options: batchBusiness,
    clearable: true,
    filterable: true
  },
  {
    label: '异常时间',
    type: 'time-slot',
    startName: 'startTime', // 返回数据时，开始时间的字段名
    endName: 'endTime', // 返回数据时，结束时间的字段名
    value: 'createdtime'
  }
]
